import React, { FC } from 'react';
import Label from "../Label/Label";
import ErrorText from "../ErrorText/ErrorText";
import { clss } from '../../../../utils/helpers/styleHelpers';
import { useAppSelector } from '../../../../store/hooks';
import { selectDirection } from '../../../../store/selectors/appSelectors';

import styles from '../../form.module.scss';

type TextAreaFieldPropTypes = {
    name: string;
    label: string;
    errorMessage: string;
    hintText?: string;
    register: any;
    orderIndex: number;
    defaultValue: any;
    style: any;
    props: any;
    onChange: (value: any) => void;
    extraContent: any;
}

const TextAreaField: FC<TextAreaFieldPropTypes> = (props) => {
    const {
        name,
        label,
        errorMessage,
        hintText,
        register,
        orderIndex,
        defaultValue,
        style,
        props: outerProps,
        onChange,
        extraContent,
    } = props;
    const direction = useAppSelector(selectDirection);

    return (
        <div key={name} style={{ order: orderIndex, ...style }}>
            <Label label={label} name={name} hintText={hintText}>
                <textarea
                    {...register(name as `${string}`)}
                    className={clss([styles.textareaField, styles.field, errorMessage ? styles.errorField : ''])}
                    defaultValue={defaultValue}
                    {...outerProps}
                    onChange={(e) => onChange(e.target.value)}
                    dir={direction}
                />
            </Label>
            <ErrorText text={errorMessage} />
            {!!extraContent && extraContent()}
        </div>
    );
};

export default TextAreaField;